import { render, staticRenderFns } from "./InstagramEdit.vue?vue&type=template&id=0c8492b8&"
import script from "./InstagramEdit.vue?vue&type=script&lang=js&"
export * from "./InstagramEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports